import React, { useState, useEffect, FC, ChangeEvent } from 'react';

interface GsmSignalAlarmProps {
  alarm: {
    type: string;
    name: string;
    group: string;
    threshold: number; // niveau de signal de (0 à 100)
  };
  onChange: (updatedAlarm: GsmSignalAlarmProps['alarm']) => void;
}

const GsmSignalAlarm: FC<GsmSignalAlarmProps> = ({ alarm, onChange }) => {
  const [threshold, setThreshold] = useState<number>(alarm.threshold);

  useEffect(() => {
    setThreshold(alarm.threshold);
  }, [alarm.threshold]);

  const handleThresholdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    setThreshold(value);
    onChange({ ...alarm, threshold: value });
  };

  return (
    <div className="form-group">
      <label htmlFor="gsmThreshold" style={{ fontWeight: 'bold' }}>GSM Signal Level:</label>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px' }}>
        <span style={{ color: 'red', fontSize: '0.85em' }}>Bad</span>

        <input
          type="range"
          id="GPSThreshold"
          min={0}
          max={100}
          value={threshold}
          onChange={handleThresholdChange}
          style={{
            width: '250px',
            background: 'linear-gradient(to right, red, orange, yellow, green)',
            height: '8px',
            borderRadius: '5px',
            appearance: 'none',
            cursor: 'pointer'
          }}
        />
        <span style={{ color: 'green', fontSize: '0.85em' }}>Good</span>
      </div>

      <div style={{ marginTop: '5px', fontSize: '0.85em' }}>
        Selected signal level: <strong>{threshold}%</strong>
      </div>
    </div>
  );
};

export default GsmSignalAlarm;
